import { render, staticRenderFns } from "./SelectorResponsibleAcceptance.vue?vue&type=template&id=d5dd4732&"
import script from "./SelectorResponsibleAcceptance.vue?vue&type=script&lang=ts&"
export * from "./SelectorResponsibleAcceptance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports